import EventPrizeFund from './EventPrizeFund'

export default EventPrizeFund
